<template>
  <div
      class="tweet-url control has-icons-right"
      :class="{
        'is-loading': status === 'loading',
        'has-icons-left': showIcon,
        'subtle-off-focus': subtleOffFocus
      }">

    <b-tooltip
        append-to-body
        ref="tooltip"
        type="is-danger"
        position="is-bottom"
        :triggers="[this.isLoggedIn ? '' : 'focus']">
      <template v-slot:content>
        <span>You need to <strong class="has-text-white">log in</strong> for this feature to work!</span>
      </template>

      <input
          ref="inputbox"
          :class="['input', this.isLoggedIn ? 'is-primary' : 'is-danger']"
          type="text"
          :placeholder=placeholder
          v-model="textInput"
          @blur="blur"
          @dragenter.prevent="$event.dataTransfer.dropEffect='none'"
          @dragover.prevent="$event.dataTransfer.dropEffect='none'"
          @drop.prevent="$event.dataTransfer.dropEffect='none'"
      >
    </b-tooltip>
    <b-icon v-if="showIcon && this.isLoggedIn" class="is-left" size="is-small"
            pack="fab" icon="twitter"></b-icon>
    <b-icon v-if="showIcon && !this.isLoggedIn" class="is-left" size="is-small"
            icon="exclamation-triangle" type="is-danger"></b-icon>

    <b-icon v-if="status === 'error'" class="is-right" size="is-small"
            icon="exclamation-triangle" type="is-danger"></b-icon>
  </div>
</template>

<script>
import tweets from "../api/tweets";
import {mapGetters, mapState} from "vuex";

export default {
  name: 'TweetUrl',
  props: {
    'subtleOffFocus': {
      type: Boolean,
      default: true
    },
    'placeholder': {
      type: String
    },
    'showIcon': {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      textInput: '',
      status: ''
    }
  },
  watch: {
    isLoggedIn: 'checkInput',
    textInput: 'checkInput'
  },
  computed: mapGetters(['isLoggedIn']),
  methods: {
    blur() {
      this.$refs.tooltip.close()
      this.status = ''
      this.$emit('blur')
    },
    checkInput() {
      if (!this.isLoggedIn) { return }
      let match = this.textInput.match(/([0-9]{2,26})(?:\/)?$/)
      if (match) {
        let s = match[0]
        this.status = 'loading'
        tweets.getTweet(s)
            .then(response => {
              this.status = ''
              this.textInput = ''
              this.$refs.inputbox.blur()
              this.$emit('tweetValidated', response.data)
            })
            .catch(() => {
              this.status = 'error'
              this.$emit('tweetFailed')
            })
      }
    }
  }

}
</script>

<style lang="scss" scoped>

/* increase opacity a bit on placeholder text */
.b-tooltip {
  width: 100%;
}

.input::placeholder {
  color: rgba(54, 54, 54, 0.5);
}

/* hide borders, shadow and icon so it just looks like text */
.tweet-url.subtle-off-focus:not(:focus-within) {
  input {
    border-color: transparent;
    box-shadow: none;
    -webkit-box-shadow: none;
  }

  .icon {
    display: none;
  }
}

/* don't make the icon bold on focus */
.tweet-url.has-icons-left .input:focus ~ .icon {
  color: #dbdbdb;
}

</style>
